module.exports = __webpack_public_path__ + "assets/cross-icon.b3f7884c.svg";